/** El aviso rojo del asistente: el error del paso, de la prueba o del detalle de la plantilla, con un link si lo trae. */
import { Link } from "react-router-dom";
import type { Aviso } from "../../logic/asistente";

export function AvisoRojo({ aviso }: { aviso: Aviso }) {
  return (
    <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" role="alert">
      {aviso.texto}
      {aviso.link && <> · <Link to={aviso.link.ruta} className="font-semibold underline">{aviso.link.label}</Link></>}
    </p>
  );
}
